import React, {
    useState
} from 'react';


import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import metadata from './PremiumAuditPage.metadata.json5';
import styles from './PremiumAuditPage.module.scss';
// import messages from './PremiumAuditPage.messages';
import { AccountDropDownValues } from '../cpmi_SelectAccountDropDown'
import { PremiumAuditCEDocumentsTable } from 'cpmi-components-platform-react'

function PremiumAuditPage(props) {
    const {
        authHeader
    } = props;
    const [currentAccount, setCurrentAccount] = useState(null)
    const [loading, setLoading] = useState(true)


   const handleValueChange = async (accountNumber) => {
        setCurrentAccount(accountNumber)
        setLoading(false)
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        premiumAuditTable: {
            currentAccount,
            authHeader,
            loading
        },
        PremiumAuditCEDocumentsTable: {
            currentAccount,
            authHeader,
            loading
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            AccountDropDownValues,
          	PremiumAuditCEDocumentsTable
        },
        resolveCallbackMap: {
            handleValueChange
        },
    };

    return (
        <MetadataContent uiProps={metadata.pageContent} overrideProps={overrideProps} {...resolvers} />
    );
}

export default withAuthenticationContext(PremiumAuditPage);
